<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Chi-siamo/Top_Chi-siamo.jpg">
<div class="content">
    <h1>Chi siamo</h1>
</div>
</div>
<!-- <br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Riserva naturale Valli Cupe</a></p>
</div>
<br> -->
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Zampino Viaggi è un tour operator incoming specializzato nella promo-commercializzazione della destinazione 
            turistica Calabria con riferimento all’intero territorio della regione, dalle coste alla montagna interna e ai 
            Parchi.
            <br>
            <br>
            L’Agenzia guidata da Giuseppe Zampino che ne segue anche la direzione tecnica, è attiva dal 2002 e gestisce 
            l’intera filiera dei servizi turistici assistendo i clienti in tutto il processo organizzativo.
            <br>
            <br>
            L’agenzia Viaggi è associata al Network nazionale “Geo Travel Network" (di proprietà del gruppo Alpitour e 
            Costa Crociere) e può vantare una rete di partner commerciali leader nei diversi settori di riferimento, 
            sul territorio sia nazionale che internazionale. Una rete di qualità che garantisce alla clientela le migliori 
            condizioni di acquisto in termini di servizi incoming, Crociere e pacchetti di viaggio.
            <br>
            <br>
            Una partnership che coinvolge allo stesso modo gli operatori turistici del territorio per assicurare servizi 
            attrattivi e funzionali, che rispondano pienamente alle esigenze degli utenti invogliati a conoscere lo splendido 
            paesaggio naturale e culturale della Calabria in chiave green e slow, in ogni periodo dell’anno.
            <br>
            <br>
            Grazie all’esperienza maturata, nel 2018 a Giuseppe Zampino è stata assegnata la presidenza di FIAVET Calabria - 
            Federazione Italiana Associazione Imprese Viaggi e Turismo e nello stesso anno entra a far parte del direttivo 
            dell’Ente Bilaterale Turismo Calabria.
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>